'use strict';

var formCommons = function () {
  var form = void 0,
      $submitBtn = void 0,
      $toHide = void 0,
      $toShow = void 0,
      submitPrevText = void 0,
      okURL = void 0,
      koURL = void 0,
      closeBtn = void 0;
  var _sendAjax = function _sendAjax(params) {
    console.log('PARAMS:', params);
    form = params.form, $submitBtn = $(params.submit$Selector), $toHide = $(params.toHide), $toShow = $(params.toShow), submitPrevText = $submitBtn.text(), okURL = params.okURL, koURL = params.koURL, closeBtn = params.close$Selector;

    var userName = void 0,
        modelName = void 0,
        modelId = void 0;
    if (params.thankyouData) {
      userName = $(params.thankyouData.fieldName).val();
      if (typeof params.thankyouData.modelName !== 'undefined') {
        modelName = params.thankyouData.modelName;
      }
      if (typeof params.thankyouData.modelId !== 'undefined') {
        modelId = params.thankyouData.modelId;
      }
    }
    $submitBtn.prop('disabled', true).text(params.submitText);

    $toShow.css('display', 'none');
    var urlTarget = params.form.action;
    var values = $(form).serialize();

    if (params.hasOwnProperty('useReCaptcha') && params.useReCaptcha === true) {
      //console.log('Use reCaptcha!');
      grecaptcha.ready(function () {
        grecaptcha.execute('6LeqXBAgAAAAAIWZ2TjRMTeCdDWVAZ42n5CTMvTF', { action: 'submit' }).then(function (token) {

          var valuesToken = values + '&token=' + token;
          values = valuesToken;

          _postAjaxToken(params, urlTarget, values);
          // .then((response) => {
          //   console.log("RESPONSE::", response)
          //   response.json()
          //       .then((data) => {
          //         // If success send form
          //         // if (data.success === true && data.score >= 0.5)
          //         //   _postAjax(params, urlTarget, values);
          //         _postAjaxToken(params, urlTarget, values, token)
          //       })
          // })
        });
      });
    } else {
      //console.log('Don\'t use reCaptcha!');
      _postAjax(params, urlTarget, values);
    }
  };

  var _postAjax = function _postAjax(params, urlTarget, values) {
    $.ajax({
      method: 'POST',
      url: urlTarget,
      data: values,
      success: function success(resp) {
        if (resp === 'OK') {
          // This part contains model and user data to display. It is currently not used.
          /* if(params.thankyouData){
            if (typeof(userName) !== 'undefined'){
              $(params.thankyouData.targetName).text(userName)
            }
              if (typeof(modelName) !== 'undefined') {
              $(params.thankyouData.targetModel).text(`NISSAN ${modelName}`.toUpperCase().replace(/E-/g, 'e-'))
            }
              if (typeof(modelId) !== 'undefined') {
              $.ajax({
                dataType: 'json',
                url: `${globalEnv}getJsonModelo?idModel=${modelId}&pais=ES`,
                success: function(resp){
                  $(params.thankyouData.targetModel).text(`NISSAN ${resp.vModelo}`.toUpperCase().replace(/E-/g, 'e-'))
                }
              })
            }
          } */

          utils.makeRequest(okURL, 'GET', formCommons.showOKPage);
          var leadType = $('.js-tipo-value').val();
          if (typeof leadType !== 'undefined') {
            //trackApp.trackLeadOmniture(leadType)
            if (leadType === 'TD') {
              var eventLabel = params.tracking.principalCodhost + '/' + params.tracking.codhost + '/' + params.tracking.model + '/' + params.tracking.motor;
              //trackApp.trackLeadGA(leadType, eventLabel)
            }
          }
        } else {
            // utils.makeRequest(koURL, 'GET', formCommons.showKOPage)
          }
      },
      error: function error(err) {
        //utils.makeRequest(koURL, 'GET', formCommons.showKOPage)
      }
    });
  };

  var _postAjaxToken = function _postAjaxToken(params, urlTarget, values, token) {
    $.ajax({
      method: 'POST',
      url: urlTarget,
      data: values,
      token: token,
      success: function success(resp) {
        if (resp === 'OK') {
          // This part contains model and user data to display. It is currently not used.
          /* if(params.thankyouData){
            if (typeof(userName) !== 'undefined'){
              $(params.thankyouData.targetName).text(userName)
            }
              if (typeof(modelName) !== 'undefined') {
              $(params.thankyouData.targetModel).text(`NISSAN ${modelName}`.toUpperCase().replace(/E-/g, 'e-'))
            }
              if (typeof(modelId) !== 'undefined') {
              $.ajax({
                dataType: 'json',
                url: `${globalEnv}getJsonModelo?idModel=${modelId}&pais=ES`,
                success: function(resp){
                  $(params.thankyouData.targetModel).text(`NISSAN ${resp.vModelo}`.toUpperCase().replace(/E-/g, 'e-'))
                }
              })
            }
          } */

          utils.makeRequest(okURL, 'GET', formCommons.showOKPage);
          var leadType = $('.js-tipo-value').val();
          if (typeof leadType !== 'undefined') {
            //trackApp.trackLeadOmniture(leadType)
            if (leadType === 'TD') {
              var eventLabel = params.tracking.principalCodhost + '/' + params.tracking.codhost + '/' + params.tracking.model + '/' + params.tracking.motor;
              //trackApp.trackLeadGA(leadType, eventLabel)
            }
          }
        } else {
          utils.makeRequest(koURL, 'GET', formCommons.showKOPage);
        }
      },
      error: function error(err) {
        utils.makeRequest(koURL, 'GET', formCommons.showKOPage);
      }
    });
  };

  var _showOKPage = function _showOKPage(resptxt) {

    $toHide.fadeOut(800, function () {
      $submitBtn.prop('disabled', false).text(submitPrevText);
      $toShow.removeClass('hidden').html(resptxt).fadeIn(400, function () {
        utils.animateScroll($toShow);
        var $closeBtn = $(closeBtn);
        $closeBtn.on('click', function () {
          location.reload();
        });
      });
    });
  };

  var _showKOPage = function _showKOPage(resptxt) {
    $submitBtn.prop('disabled', false).text(submitPrevText);
    $toHide.fadeOut(800, function () {
      $toShow.removeClass('hidden').html(resptxt).fadeIn(400, function () {
        utils.animateScroll($toShow);
        var $closeBtn = $(closeBtn);
        $closeBtn.on('click', function () {
          $toShow.fadeOut(400, function () {
            $toHide.fadeIn(400);
          });
        });
      });
    });
  };

  return {
    sendAjax: _sendAjax,
    showOKPage: _showOKPage,
    showKOPage: _showKOPage
  };
}();